import { render, staticRenderFns } from "./CentersTypesAdd.vue?vue&type=template&id=f31b26be&scoped=true&"
import script from "./CentersTypesAdd.vue?vue&type=script&lang=js&"
export * from "./CentersTypesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31b26be",
  null
  
)

export default component.exports